import gql from "graphql-tag"

const START_MODIFICATION = gql`
  mutation startModification($modificationId: ID!, $input: InputOrderModificationOrderLinesStart!) {
    Order {
      startOrderModificationOrderLines(modificationId: $modificationId, input: $input) {
        status
      }
    }
  }
`

export default START_MODIFICATION
